import { render, staticRenderFns } from "./baseDienstplan.vue?vue&type=template&id=2d5877ee&scoped=true"
import script from "./baseDienstplan.vue?vue&type=script&lang=ts"
export * from "./baseDienstplan.vue?vue&type=script&lang=ts"
import style0 from "./baseDienstplan.vue?vue&type=style&index=0&id=2d5877ee&prod&lang=css"
import style1 from "./baseDienstplan.vue?vue&type=style&index=1&id=2d5877ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5877ee",
  null
  
)

export default component.exports